module.exports = __webpack_public_path__ + "static/media/tx-submit.e0804bfb.svg";